import React from 'react';
import styled from 'styled-components';
import { MobileWidth } from '../sharedData/Constants';
import {ReactComponent as ArrowRight} from '../assets/images/arrow_right.svg';

const CardButton = (props) => {
    return (
      <StyledLink target="_blank" href={props.link}>
        {props.title}&nbsp;<ArrowRight/>
      </StyledLink>
    );
}

const StyledLink = styled.a`
  width: 200px;
  height: 58px;
  background-color: #000000;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 25px;
  cursor: pointer;
  margin-top: 25px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  svg{
	  margin-top: 4px;
  }
  @media screen and (max-width: ${MobileWidth}){
    width: 155px;
    height: 45px;
    font-size: 15px;
    margin-top: 13px;
  }
`;

export default CardButton;